import { getActions } from './common/common.actions';
import { Injectable } from '@angular/core';
import { CommonEffects } from '@redux/common/common.effects';
import { getSelectors } from '@redux/common/common.selector';
import { Document } from '@models/community/document.model';

export const documentStateKey = 'ResidentsState';

export const documentActions = {
  ...getActions<Document>(documentStateKey),
};
//
export const selectDocumentsBase = getSelectors<Document>(documentStateKey);
export const selectDocuments = {
  ...selectDocumentsBase,
};

@Injectable()
export class DocumentEffects extends CommonEffects<Document> {
  constructor() {
    super();
    Object.assign(this, this.createEffects(documentActions, selectDocuments));
  }
}
